import React from "react";
import PropTypes from "prop-types";
import { useLive } from "../LiveProvider";
import {
  Badge,
  Group,
  GroupTitle,
  Listing,
  ListingImage,
  ListingContent,
  ListingAddress,
  ListingData
} from "./styled/live-listings";

function LiveListings({
  listingFormat,
  setPreviewListingId,
  setHoverListingId
}) {
  const { visibleListingGroups } = useLive();

  return Object.entries(visibleListingGroups).map(([status, listings]) => (
    <Group key={status}>
      <GroupTitle className="group-title-live-listings">
        <Badge
          style={{
            backgroundColor: (listings[0] || { statusColor: "#000" })
              .statusColor
          }}>
          {listings.length}
        </Badge>
        {status}
      </GroupTitle>
      {listings.map((listing) => (
        <Listing
          key={listing.recordId}
          isGhost={listing.isGhost}
          onClick={(e) => {
            e.stopPropagation();
            setPreviewListingId(listing.recordId);
          }}
          onMouseEnter={() => setHoverListingId(listing.recordId)}
          onMouseLeave={() => setHoverListingId(null)}>
          <ListingImage src={listing.photos[0]} alt={listing.address} />
          <ListingContent>
            <ListingAddress
              title={listing.address}
              className="group-listing-address">
              {listing.address}
            </ListingAddress>
            <ListingData className="group-listing-data">
              {listingFormat(listing)}
            </ListingData>
          </ListingContent>
        </Listing>
      ))}
    </Group>
  ));
}

LiveListings.defaultProps = {
  listingFormat: () => {},
  setPreviewListingId: () => {},
  setHoverListingId: () => {}
};

LiveListings.propTypes = {
  listingFormat: PropTypes.func,
  setPreviewListingId: PropTypes.func,
  setHoverListingId: PropTypes.func
};

export default LiveListings;
